var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", "max-width": "800px" },
      model: {
        value: _vm.opened,
        callback: function($$v) {
          _vm.opened = $$v
        },
        expression: "opened"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _c("span", [
                _vm._v(
                  "\n        Enviar notificações para os profissionais na fase:\n        "
                ),
                _c("i", [_vm._v(_vm._s(_vm.name.toLowerCase()))])
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "accent",
                    rounded: "",
                    icon: "",
                    outlined: ""
                  },
                  on: { click: _vm.closeDialog }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c("v-text-field", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|max:100",
                    expression: "'required|max:100'"
                  }
                ],
                attrs: {
                  required: "",
                  name: "title",
                  label: "título",
                  "data-vv-as": "título",
                  "prepend-inner-icon": "mdi-format-title",
                  counter: 100,
                  value: _vm.title,
                  error: _vm.errors.has("title"),
                  "error-messages": _vm.errors.first("title")
                },
                on: { input: _vm.setTitle }
              }),
              _vm._v(" "),
              _c("v-textarea", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|max:250",
                    expression: "'required|max:250'"
                  }
                ],
                attrs: {
                  required: "",
                  "auto-grow": "",
                  rows: "3",
                  name: "message",
                  label: "mensagem",
                  "prepend-inner-icon": "mdi-subtitles-outline",
                  counter: 250,
                  value: _vm.message,
                  error: _vm.errors.has("message"),
                  "error-messages": _vm.errors.first("message")
                },
                on: { input: _vm.setMessage }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            { staticClass: "py-3" },
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", rounded: "", loading: _vm.loader },
                  on: { click: _vm.sendProfessionalNotification }
                },
                [
                  _vm._v("\n        enviar notificação\n        "),
                  _c("v-icon", { attrs: { right: "", small: "" } }, [
                    _vm._v("send")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78c9f63d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78c9f63d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfessionalRegisterFlow/components/Notification.vue
// module id = null
// module chunks = 